import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import Layout from '../components/Layout';
import Seo from '../components/global/Seo';
import { Button, Card } from '../components/elements';
import Hero from '../components/home/Hero';
import FilterOption from '../components/category/FilterOption';

const Category = ({ data }) => {
  const { category, cateImage } = data;
  const allNews = category.nodes;
  const [list, setList] = useState([...allNews.slice(0, 9)]);
  const [articleLoadMore, setLoadMore] = useState(false);

  const [hasMore, setHasMore] = useState(allNews.length > 10);

  // load more button click
  const handleLoadMore = () => {
    setLoadMore(true);
  };

  // handle loading more articles
  useEffect(() => {
    if (articleLoadMore && hasMore) {
      const currentLength = list.length;
      const isMore = currentLength < allNews.length;
      const nextResults = isMore
        ? allNews.slice(currentLength, currentLength + 10)
        : [];
      setList([...list, ...nextResults]);
      setLoadMore(false);
    }
  }, [articleLoadMore, hasMore]);

  // check if there is more
  useEffect(() => {
    const isMore = list.length < allNews.length;
    setHasMore(isMore);
  }, [list]);

  return (
    <Layout>
      <Seo
        title={cateImage.title}
        description={cateImage.description}
        image={cateImage.seoFeaturedImage.asset.url}
      />
      <Hero
        title={cateImage.title}
        description={cateImage.description}
        image={cateImage.seoFeaturedImage}
      />
      <section className="section">
        <div className="container">
          <FilterOption />
          <div className="columns is-multiline">
            {list.map((article) => (
              <Card
                image={article.featuredImage.asset.gatsbyImageData}
                alt={article.featuredImage.asset.alt || 'Capextax'}
                title={article.title}
                key={article.id}
                date={article.date}
                subtitle={article.articleSubtitle}
                slug={`/news/${
                  article.slug.current === 'homepage'
                    ? '/'
                    : article.slug.current
                }`}
              />
            ))}
          </div>
          {hasMore ? (
            <div className="load">
              <Button
                fullWidth
                backColor="var(--blue)"
                onClick={handleLoadMore}
              >
                Load More
              </Button>
            </div>
          ) : null}
        </div>
      </section>
    </Layout>
  );
};

export default Category;

Category.propTypes = {
  data: PropTypes.object.isRequired,
};

export const query = graphql`
  query ($slug: String!) {
    category: allSanityArticles(
      sort: { fields: date, order: DESC }
      filter: {
        categories: { elemMatch: { slug: { current: { eq: $slug } } } }
      }
    ) {
      nodes {
        id
        title
        articleSubtitle
        date
        slug {
          current
        }
        featuredImage {
          alt
          asset {
            _id
            gatsbyImageData(width: 392, height: 260)
          }
        }
        categories {
          title
        }
      }
    }
    cateImage: sanityCategory(slug: { current: { eq: $slug } }) {
      seoFeaturedImage {
        asset {
          gatsbyImageData
          url
        }
      }
      title
      description
    }
  }
`;
